const DialogTitle = () => {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          height: 48,
          paddingInline: 62,
        },
      },
    },
  };
};

export default DialogTitle;
